import React, { Component } from 'react';
import {
  Button,
  FormGroup,
  FormInput,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'shards-react';

class CloseComplaint extends Component {
  state = {
    isClosingNoteEmpty: true
  };
  componentDidMount() {
    console.table(this.props);
  }

  render() {
    return (
      <Modal
        open={true}
        toggle={this.props.closeModal}
        backdrop={true}
        backdropClassName='backdrop'
        modalClassName='modal'
        centered={true}
        role='dialog'
      >
        <ModalHeader className='bg-primary1'>Are you sure?</ModalHeader>
        <ModalBody>
          Are you sure to close this complaint?
          <form id='closingForm' name='closingForm'>
            <FormGroup>
              <label>Enter closing note (Internal Use)</label>
              <FormInput
                name='note'
                onChange={e => this.props.handleChange(e)}
                placeholder='Why are you closing this note?'
                required
              />
            </FormGroup>
            {/* Get input for sending email for closing the ticket */}
            <FormGroup>
              <label>Message for complainant</label>
              <FormInput
                name='closingNote'
                onChange={e => {
                  this.props.handleChange(e);
                  this.setState({ isClosingNoteEmpty: false });
                }}
                placeholder='What to tell the client on closing this ticket?'
                required
              />
            </FormGroup>
          </form>
        </ModalBody>
        <ModalFooter className='home-buttons d-flex w-100 justify-content-between'>
          <Button
            theme='danger'
            type='dismiss'
            onClick={() => {
              this.props.closeModal();
            }}
          >
            Cancel
          </Button>
          <Button
            theme='success'
            type='submit'
            disabled={this.state.isClosingNoteEmpty}
            name='go_profile'
            onClick={() => {
              this.props.handleCloseComplaint(
                this.props.note,
                this.props.complaint
              );
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

// const CloseComplaint = ({ closeModal, handleCloseComplaint, handleChange, note, closingNote }) => {
// 	//TODO convert to class react and have form validation
// 	return (
// 		<Modal
// 			open={true}
// 			toggle={closeModal}
// 			backdrop={true}
// 			backdropClassName="backdrop"
// 			modalClassName="modal"
// 			centered={true}
// 			role="dialog"
// 		>
// 			<ModalHeader className="bg-primary1">Are you sure?</ModalHeader>
// 			<ModalBody>
// 				Are you sure to close this complaint?
// 				<form id="closingForm" name="closingForm">
// 					<FormGroup>
// 						<label>Enter closing note (Internal Use)</label>
// 						<FormInput
// 							name="note"
// 							onChange={(e) => handleChange(e)}
// 							placeholder="Why are you closing this note?"
// 							required
// 						/>
// 					</FormGroup>
// 					{/* Get input for sending email for closing the ticket */}
// 					<FormGroup>
// 						<label>Message for complainant</label>
// 						<FormInput
// 							name="closingNote"
// 							value={closingNote}
// 							onChange={(e) => handleChange(e)}
// 							placeholder="What to tell the client on closing this ticket?"
// 							required
// 						/>
// 					</FormGroup>
// 					<Button
// 						theme="danger"
// 						type="dismiss"
// 						onClick={() => {
// 							closeModal();
// 						}}
// 					>
// 						Cancel
// 					</Button>
// 					<Button
// 						theme="success"
// 						type="submit"
// 						name="go_profile"
// 						onClick={() => {
// 							handleCloseComplaint(note);
// 						}}
// 					>
// 						Yes
// 					</Button>
// 				</form>
// 			</ModalBody>
// 			{/* <ModalFooter className="home-buttons d-flex w-100 justify-content-between" /> */}
// 		</Modal>
// 	);
// };

export default CloseComplaint;
